<template lang="pug">
nav.navbar.navbar-default.navbar-fixed-top
  .container-fluid
    .navbar-header
      button.navbar-toggle.collapsed(type="button" data-target="#bs-navbar-collapse-1" aria-expanded="false")
        span.sr-only Toggle navigation
        span.icon-bar
        span.icon-bar
        span.icon-bar
      router-link.navbar-brand(to="/" tag="span" active-class="active" exact="" ref="brand") JOY Server&nbsp;
        small(v-if="isUserAuthenticated")
          span(v-tooltip.bottom="'backend'") {{this.$store.state.config.versionBackend}}
    #bs-navbar-collapse-1.collapse.navbar-collapse
      ul.nav.navbar-nav
        router-link(v-if="isUserAuthenticated && $store.getters.hasRole(['admin', 'manager', 'user'])" to="/devices/installed" tag="li" active-class="active")
          a(v-tooltip.bottom="lang['Installed kiosks']")
            i.fa.fa-lg.fa-tablet(aria-hidden="true")
        router-link(v-if="isUserAuthenticated && $store.getters.hasRole(['admin', 'manager'])" to="/devices/uninstalled" tag="li" active-class="active")
          a(v-tooltip.bottom="lang['Uninstalled kiosks']")
            i.fa.fa-lg.fa-tablet.text-primary(aria-hidden="true")
        router-link(v-if="isUserAuthenticated" to="/findpayments" tag="li" active-class="active")
          a(v-tooltip.bottom="lang['Find payment']")
            i.fa.fa-lg.fa-credit-card(aria-hidden="true")
        router-link(v-if="isUserAuthenticated && $store.getters.hasRole(['admin', 'manager'])" to="/enabledevices" tag="li" active-class="active")
          a(v-tooltip.bottom="lang['Enable/Disable Screens']")
            i.fa.fa-lg.fa-tablet-alt(aria-hidden="true")
        router-link(v-if="isUserAuthenticated && $store.getters.hasRole(['admin', 'manager', 'operations'])" to="/dashboard" tag="li" active-class="active")
          a(v-tooltip.bottom="lang['Dashboard']")
            i.fa.fa-lg.fa-desktop(aria-hidden="true")
        router-link(v-if="isUserAuthenticated && $store.getters.hasRole(['admin', 'manager', 'operations'])" to="/dashboard-report" tag="li" active-class="active")
          a(v-tooltip.bottom="lang['Dashboard CSV Raport']")
            i.fa.fa-lg.fa-chart-bar(aria-hidden="true")
      userNav(v-if="isUserAuthenticated" :lang="lang")
      span.navbar-text.navbar-right(v-if="isUserAuthenticated && ppath == 'devices'")
      ul.nav.navbar-nav.navbar-right
        router-link(v-if="isUserAuthenticated && ppath == 'devices'" :to="$route.path" tag="li" active-class="inactive" @click.native="changeDeviceViewType()")
          a(v-tooltip.bottom="lang['List']")
            i.fa.fa-lg.fa-list(:class="{ 'text-primary': isDeviceViewList }" aria-hidden="true")
      form.navbar-form.navbar-right(role="search" v-if="isUserAuthenticated && ppath == 'devices'" @submit.prevent="")
        .checkbox
          label {{this.$store.getters.devices.length}} &nbsp;
            button.btn.btn-default.btn-sm.disabled(style="padding-left: 0;" v-tooltip.bottom="lang['All Kiosks']")
              i.fa.fa-hashtag
        .checkbox
          label {{errored.length}} &nbsp;
            input(type="checkbox" v-model="checkErrored")
            button.btn.btn-default.btn-sm.disabled(v-tooltip.bottom="lang['Kiosks with errors']")
              i.fa.fa-exclamation-triangle.text-danger
        .checkbox
          label {{inActive.length}} &nbsp;
            input(type="checkbox" v-model="checkInactive")
            button.btn.btn-default.btn-sm.disabled(v-tooltip.bottom="lang['Inactive Kiosks']")
              i.fa.fa-heartbeat.text-danger
        .checkbox
          label {{standby.length}} &nbsp;
            input(type="checkbox" v-model="checkStandby")
            button.btn.btn-default.btn-sm.disabled(v-tooltip.bottom="lang['Standby Kiosks']")
              i.fa.fa-heartbeat.text-primary
        .form-group
          input.form-control.input-sm(type="text" v-model="filter" :placeholder="lang['Name, descr., uuid']" @change="filterDevices" @keydown.esc="cancelDevicesFilter")
        button.btn.btn-default(type="button" @click="cancelDevicesFilter" v-tooltip.bottom="lang['Clear filter']")
          i.fa.fa-lg.fa-times-circle.text-warning(aria-hidden="true")
      ul.nav.navbar-nav.navbar-right(v-if="isUserAuthenticated && ppath == 'devices'")
        li
          a(href="#" v-tooltip.bottom="lang['Next page']" @click.prevent="$store.commit('SET_DEVICES_PAGE', $store.state.devicePage - 1)" active-class="inactive")
            i.fa.fa-lg.fa-angle-left(aria-hidden="true")
        li
          p.navbar-text {{$store.state.devicePage}}
        li(v-if="isUserAuthenticated && ppath == 'devices'")
          a(href="#" v-tooltip.bottom="lang['Next page']" @click.prevent="$store.commit('SET_DEVICES_PAGE', $store.state.devicePage + 1)" active-class="inactive")
            i.fa.fa-lg.fa-angle-right(aria-hidden="true")
      form.navbar-form.navbar-right(role="search" v-if="isUserAuthenticated && ppath == 'devices'" @submit.prevent="")
        select.perPage.form-control(@change="onChangePerPage($event)" v-model="perPage")
          option(value=8 selected="selected") 8
          option(value=16) 16
          option(value=24) 24
          option(value=48) 48
          option(value=96) 96
      p.navbar-text.navbar-right(v-if="isUserAuthenticated && ppath == 'devices'") {{lang['Show']}}:
      form.navbar-form.navbar-right(v-if="isUserAuthenticated && ppath == 'devices'" @submit.prevent="")
        select.perPage.form-control(v-model="selectedNetwork")
          option(value="0") {{lang['all']}}
          option(v-for="(network, index) in userNetworks" :value="network.id") {{network.name}}
      p.navbar-text.navbar-right(v-if="isUserAuthenticated && ppath == 'devices'") {{lang['Network']}}:
</template>

<script>
import userNav from '@/components/user/UserNav'
import {mapState} from 'vuex'

export default {
  name: 'navigation',
  props: ['lang'],
  components: {
    userNav
  },
  computed: {
    ...mapState(['filterNetwork']),
    errored () {
      return this.$store.getters.errored
    },
    inActive () {
      return this.$store.getters.inActive
    },
    standby () {
      return this.$store.getters.standby
    },
    isUserAuthenticated () {
      return this.$store.state.isUserAuthenticated
    },
    ppath () {
      return this.$route.name
    },
    isDeviceViewList () {
      return this.$store.state.deviceViewType === 'list'
    },
    userNetworks () {
      return this.$store.getters.networks.filter((n) => this.$store.getters.user.networks.includes(n.id)).sort((a, b) => a.name.localeCompare(b.name))
    },
    selectedNetwork: {
      get () {
        return this.filterNetwork
      },
      set (newValue) {
        this.$store.commit('SET_DEVICES_FILTER_NETWORK', newValue)
      }
    }
  },
  watch: {
    checkErrored (newV, oldV) {
      this.$store.commit('SET_DEVICES_FILTER_STATE', newV)
    },
    checkInactive (newV, oldV) {
      this.$store.commit('SET_DEVICES_FILTER_ACTIVE', newV)
    },
    checkStandby (newV, oldV) {
      this.$store.commit('SET_DEVICES_FILTER_STANDBY', newV)
    }
  },
  methods: {
    onChangePerPage (event) {
      this.$store.commit('SET_DEVICES_PERPAGE', event.target.value)
    },
    nextHash () {
      return '#' + new Date().getTime()
    },
    changeDeviceViewType () {
      this.$store.commit('CHANGE_DEVICE_VIEW_TYPE')
    },
    filterDevices () {
      this.$store.dispatch('addDeviceFilter', {type: 'name', needle: this.filter})
    },
    cancelDevicesFilter () {
      this.filter = ''
      this.$store.commit('CANCEL_DEVICES_FILTER')
    }
  },
  data () {
    return {
      perPage: 8,
      filter: '',
      checkErrored: false,
      checkInactive: false,
      checkStandby: false
    }
  }
}
</script>
<style lang="sass" scoped>
  .perPage
    height: 24px
    margin: 8px 0
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue